import type { GetAllAvailableOrganizationsRequiredTagsEnum } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useQuery } from '@tanstack/react-query';

import { DATA_INIT_CACHING } from '@/configs/query';
import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import { useGrapevineOrganizationApi } from '@/features/api/hooks/grapevine-organization/useGrapevineOrganizationApi';
import { useAuth } from '@/features/authorization/provider/useAuth';

export const useGetOrganizations = (
  tags?: GetAllAvailableOrganizationsRequiredTagsEnum[]
) => {
  const { isAuthenticated } = useAuth();

  const api = useGrapevineOrganizationApi();
  return useQuery({
    queryKey: [API_CACHE_KEYS.ORGANIZATIONS, tags],
    queryFn: () =>
      api.getAllAvailableOrganizations({ requiredTags: tags && new Set(tags) }),
    enabled: isAuthenticated,
    ...DATA_INIT_CACHING
  });
};
